import { LegalLayout } from "./LegalLayout";

export function PrivacyPolicyPage() {
  return (
    <LegalLayout title="個人情報保護方針">
      <p className="text-white/50 text-sm">制定日: 2026年2月17日 / 最終更新日: 2026年2月17日</p>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">1. 個人情報保護の目的</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          株式会社WakeApp（以下「当社」）では、業務上当社が取り扱う全ての個人情報を適切に保護する事を重要な社会的責務として考え、情報主体の権利の保護、個人情報に関する法規制等を遵守し、最新のＩＴ技術の動向、社会的要請の変化、経営環境の変動等を常に着目し、個人情報保護マネジメントシステムの継続的改善、規則の制定および管理体制の確立に全社をあげて取り組みます。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">
          2. ご利用者から提供される個人情報の利用について
        </h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社がご利用者から個人情報をご提供いただくときは、提供する当社のサービス（以下「当社サービス」といい、当社のウェブサイトを「当社サイト」といいます。）における取得目的をあらかじめ明示し、適法且つ公正な方法で取得します。また個人情報の利用は以下に定める目的のために行います。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>当社サービスの提供、運用および維持のため</li>
          <li>当社サービスのアカウント作成および認証のため</li>
          <li>利用企業の管理（チーム管理、ロール管理を含む）のため</li>
          <li>ご利用者の本人確認のため</li>
          <li>当社サービスの利用料金の請求および決済処理のため</li>
          <li>当社サービスに関する案内、お知らせ、アップデート情報等の送信のため</li>
          <li>当社サービスに対するお問い合わせ、ご相談およびサポート対応のため</li>
          <li>当社サービスの改善および新機能の開発のため</li>
          <li>
            利用状況の分析および統計情報の作成（個人を特定しない形式に加工したうえで実施）のため
          </li>
          <li>当社サービスの不正利用の防止およびセキュリティの確保のため</li>
          <li>
            利用者がブラウザ拡張機能を通じて送信した情報の処理（情報の解析・構造化、整形、コンテンツの生成等）のため
          </li>
          <li>法令に基づく対応のため</li>
          <li>その他各種連絡、対応管理、関連資料送付等のため</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">3. 第三者から取得する情報</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社は、当社サービスの運営において必要性があり適用法令が許容する限りにおいて、当社サービスのご利用者および取引先の情報の提供を第三者に要請して、または一般に公表されている情報から、信用情報並びに不正行為等の防止および対応に必要な情報等を取得する場合があります。また、当社サービスのご利用者および取引先からの同意がある場合にも、その同意に基づいて、第三者から当社サービスのご利用者および取引先の個人情報を取得または受領することがあります。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">4. 個人情報の提供</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社は、法律に基づく命令等による場合と利用目的の範囲で個人情報の利用及び第三者への提供をすることがあります。ただし、以下のいずれかに該当する場合を除き、ご利用者の個人情報を第三者に提供することはありません。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>ご利用者本人の同意がある場合</li>
          <li>法令に基づく場合</li>
          <li>
            人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
          </li>
          <li>
            公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
          </li>
          <li>
            国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">5. 個人情報の適正管理</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社は、お預かりした個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス、紛失、破壊、改ざんおよび漏えい等の防止のため、以下の安全管理措置を講じます。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>個人情報の取扱いに関する責任者の設置および取扱規程の整備</li>
          <li>従業者に対する個人情報の適正な取扱いについての教育・啓発の実施</li>
          <li>個人情報にアクセスできる従業者の必要最小限への限定</li>
          <li>クライアントとサーバー間の通信の暗号化</li>
          <li>利用企業ごとのデータアクセスの論理的分離</li>
          <li>安全な認証方式の採用および多層的な権限管理の実装</li>
          <li>クレジットカード番号等の機微な決済情報の非保持（外部決済サービスへの委託）</li>
          <li>アクセスログの監視による不正アクセスの検知</li>
          <li>個人情報の取扱状況の定期的な点検</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">6. AI処理に関する取扱い</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社サービスでは、利用者がブラウザ拡張機能を通じて送信した情報の処理において、外部AIサービスを利用したAI処理（テキストの解析、構造化および生成処理）を行います。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>
            AI処理の内容は、プロフィール情報の解析・構造化、情報の整形、コンテンツの生成、およびスキルチェック等です。
          </li>
          <li>
            当社は、外部AIサービスに対してモデル学習にデータを使用しない設定（学習オプトアウト）を適用しています。
          </li>
          <li>当社は、送信情報を当社独自のAIモデルの学習・訓練に使用しません。</li>
          <li>
            AI処理により生成された出力結果は、当社サービスの機能提供の範囲内でのみ使用され、それ以外の目的に使用することはありません。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">7. 利用者の責任</h2>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>利用者は、送信する情報の内容について自ら責任を負います。</li>
          <li>利用者は、情報を取得するウェブサイトの利用規約を遵守する責任を負います。</li>
          <li>
            利用者は、送信情報に関して第三者との間で問題が生じた場合、自らの責任において解決するものとします。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">8. データの保存および削除</h2>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>
            ご利用者のアカウント情報、所属情報および利用履歴は、利用契約の存続期間中保存し、アカウント削除時に削除します。
          </li>
          <li>
            送信情報は、利用者が当社サービス上で削除するか、またはアカウント解約時に削除されます。
          </li>
          <li>
            利用企業がアカウントを解約した場合、当社は解約日から30日以内に、当該利用企業に関連するすべてのデータを削除します。ただし、法令に基づく保存義務がある情報については、当該義務期間が満了するまで保存します。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">9. 個人情報の開示・訂正・削除</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社が保有する個人情報の開示、訂正または削除を求められたときは、ご本人確認後、速やかに対応します。また、個人情報に関してご利用者本人から利用もしくは提供の拒否を求められたとき、および苦情、相談の申し出を受けたときは、個人情報に関する本人の権利を尊重し、誠意をもって対応します。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">10. 免責</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          以下の場合は、第三者による個人情報の取得に関し、当社は何らの責任を負いません。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>
            ご利用者ご本人が当社サービスの機能または別の手段を用いて第三者に個人情報を明らかにした場合
          </li>
          <li>ご利用者が当社サービス上に入力した情報等により、個人が識別できてしまった場合</li>
          <li>
            第三者が当社サービス外（当社サイトからリンクの張られている他のサイト含む）で個人情報を取得した場合
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">11. クッキー（Cookie）の利用について</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社サイトおよび当社サービスのブラウザ拡張機能では、以下の目的でクッキーおよびブラウザのストレージ機能を使用します。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>認証セッション情報の保持</li>
          <li>ご利用者の設定情報の保存</li>
          <li>サービス機能の提供に必要な一時的なデータの保持</li>
          <li>
            当社サイトのアクセス解析（収集される情報は匿名化されており、個人を特定するものではありません）
          </li>
        </ol>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          ご利用者は、ブラウザの設定によりクッキーの受け入れを拒否することができます。ただし、クッキーを拒否した場合、当社サービスの一部の機能をご利用いただけない場合があります。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">12. 本方針の変更</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          当社は、法令の改正、社会情勢の変化、当社サービスの内容変更その他の事由により、本方針を変更することがあります。変更後の本方針は、当社所定の方法（当社サービス上での掲示、メールによる通知等）により公表した時点から効力を生じます。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">13. お問い合わせ窓口</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          個人情報の取扱いに関するお問い合わせ、開示等の請求、苦情およびご相談は、下記窓口にて受付けております。
        </p>
        <p className="mt-3 text-on-surface-variant">
          株式会社WakeApp 個人情報保護担当
          <br />
          メール: privacy@wakeapp.co.jp
        </p>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          ご質問やご意見がございましたら、上記窓口までご連絡ください。
        </p>
      </section>

      <hr className="mt-12 border-white/10" />
      <p className="mt-4 font-semibold text-white">株式会社WakeApp</p>
    </LegalLayout>
  );
}
